/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".col-form-label[_ngcontent-%COMP%]{text-align:right!important}.form-group[_ngcontent-%COMP%]{margin-bottom:5px}.text-danger[_ngcontent-%COMP%]{color:#a94442!important}th[_ngcontent-%COMP%]{text-align:center}"];
export { styles as styles };
